"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dom_utils_1 = require("../../../../utils/dom-utils");
window.addEventListener("load", () => {
    if (window.innerWidth >= 992) {
        const agendaWrapper = document.querySelector('.agenda-table__wrapper');
        const tables = (0, dom_utils_1.queryAll)('.agenda-table__wrapper .agenda-table');
        if (agendaWrapper) {
            const rows1 = tables[0].querySelectorAll('.agenda-table__row');
            const rows2 = tables[1].querySelectorAll('.agenda-table__row');
            rows1.forEach((row, index) => {
                if (rows2[index]) {
                    const height1 = row.offsetHeight;
                    const height2 = rows2[index].offsetHeight;
                    const maxHeight = Math.max(height1, height2);
                    row.style.height = `${maxHeight}px`;
                    rows2[index].style.height = `${maxHeight}px`;
                }
            });
        }
    }
});
